"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_TYPE = exports.ANSWER_TYPES = exports.COST_TYPE = exports.GameplaySide = exports.SIDE = exports.STORY_STATE = void 0;
var STORY_STATE;
(function (STORY_STATE) {
    STORY_STATE[STORY_STATE["None"] = 0] = "None";
    STORY_STATE[STORY_STATE["Dialogue"] = 1] = "Dialogue";
    STORY_STATE[STORY_STATE["Choice"] = 2] = "Choice";
    STORY_STATE[STORY_STATE["ChoiceResult"] = 3] = "ChoiceResult";
    STORY_STATE[STORY_STATE["Text"] = 4] = "Text";
    STORY_STATE[STORY_STATE["Data"] = 5] = "Data";
    STORY_STATE[STORY_STATE["Input"] = 6] = "Input";
    STORY_STATE[STORY_STATE["Ending"] = 7] = "Ending";
    STORY_STATE[STORY_STATE["Results"] = 8] = "Results";
    STORY_STATE[STORY_STATE["Quiz"] = 9] = "Quiz";
    STORY_STATE[STORY_STATE["PlayerSelect"] = 10] = "PlayerSelect";
    STORY_STATE[STORY_STATE["Narrator"] = 11] = "Narrator";
    STORY_STATE[STORY_STATE["Texting"] = 12] = "Texting";
    STORY_STATE[STORY_STATE["Thinking"] = 13] = "Thinking";
    STORY_STATE[STORY_STATE["LoginPrompt"] = 14] = "LoginPrompt";
    STORY_STATE[STORY_STATE["ChooseFtue"] = 15] = "ChooseFtue";
    STORY_STATE[STORY_STATE["FtueEnd"] = 16] = "FtueEnd";
    STORY_STATE[STORY_STATE["Reaction"] = 17] = "Reaction";
})(STORY_STATE = exports.STORY_STATE || (exports.STORY_STATE = {}));
var SIDE;
(function (SIDE) {
    SIDE["LEFT"] = "left";
    SIDE["RIGHT"] = "right";
    SIDE["CENTER"] = "center";
})(SIDE = exports.SIDE || (exports.SIDE = {}));
var GameplaySide;
(function (GameplaySide) {
    GameplaySide["SIDE_LEFT"] = "left";
    GameplaySide["SIDE_RIGHT"] = "right";
    GameplaySide["SIDE_CENTER"] = "center";
})(GameplaySide = exports.GameplaySide || (exports.GameplaySide = {}));
var COST_TYPE;
(function (COST_TYPE) {
    COST_TYPE["COIN"] = "coin";
    COST_TYPE["HEART"] = "heart";
    COST_TYPE["KEY"] = "key";
    COST_TYPE["FREE"] = "free";
})(COST_TYPE = exports.COST_TYPE || (exports.COST_TYPE = {}));
var ANSWER_TYPES;
(function (ANSWER_TYPES) {
    ANSWER_TYPES["EROTIC"] = "erotic";
    ANSWER_TYPES["ROMANTIC"] = "romantic";
    ANSWER_TYPES["ACTIVE"] = "active";
    ANSWER_TYPES["PASSIVE"] = "passive";
    ANSWER_TYPES["FTUE"] = "ftue";
    ANSWER_TYPES["MULTI"] = "multi";
    ANSWER_TYPES["FREE"] = "free";
    ANSWER_TYPES["PAID"] = "paid";
})(ANSWER_TYPES = exports.ANSWER_TYPES || (exports.ANSWER_TYPES = {}));
var UPDATE_TYPE;
(function (UPDATE_TYPE) {
    UPDATE_TYPE[UPDATE_TYPE["ANSWER_DATA"] = 1] = "ANSWER_DATA";
    UPDATE_TYPE[UPDATE_TYPE["ANSWER_SELECT"] = 2] = "ANSWER_SELECT";
    UPDATE_TYPE[UPDATE_TYPE["DISABLE_BUTTONS"] = 3] = "DISABLE_BUTTONS";
    UPDATE_TYPE[UPDATE_TYPE["VOTES_EXTRAS"] = 4] = "VOTES_EXTRAS";
})(UPDATE_TYPE = exports.UPDATE_TYPE || (exports.UPDATE_TYPE = {}));
// TODO: will implement these later
// declare global {
//     const __VER__: string;
//     const __DEV__: boolean;
// }
